module.exports = __webpack_public_path__ + "img/key-skeleton-left-right.fd1faddc.svg";